import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import i18nBackend  from 'i18next-http-backend';
import  LanguageDetector  from 'i18next-browser-languagedetector';

i18n
  .use(i18nBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    detection: {
      order: ['cookie', 'localStorage'],
      caches: ['cookie'],
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

export default i18n;